import querystring from 'querystring';

import _ from 'lodash';

import splitHashParams from './splitHashParams';

const filterEmptyKeys = obj => _.pickBy(obj, (val, key) => !!key);

const extractParamsFromHash = (url = '') => {
  const params = querystring.parse(splitHashParams(url).queryString);
  // Handles a params object that was extracted from an URL with a trailing `&`,
  // which would result in an empty key/value pair.
  return filterEmptyKeys(params);
};

export default extractParamsFromHash;
